const Reducers = (state = {}, action) => {
  switch (action.type) {
    case 'SET_SESSION':
      return {
        ...state,
        session: action.session
      }
    case 'NOTIFICATION_SALE_ECOMMERCE':
      return {
        ...state,
        session: {
          ...state.session,
          notifications: {
            ...state.session.notifications,
            sale_ecommerce: state.session.notifications.sale_ecommerce.map(notification => {
              if (parseInt(notification.id_notification) === parseInt(action.id_notification)) {
                notification.is_read = 1
              }
  
              return notification
            })
          }
        }
      }
    default:
      return state;
  }
}

export default Reducers;